import {
    memo,
} from 'react'
import useLabel from 'app/hooks/useLabel'
import SkyNetDataGrid, {
    SelectionType,
} from 'app/shared-components/SkyNetDataGrid'
import applyDataToDataSource from 'app/shared-components/SkyBaseDataGrid/utils/applyDataToDataSource'
import {
    finalSelectionAdditionalFeesColumns,
} from './finalSelection.columns'

export default memo(({
    rows,
    defaultSelected,
    handleSelect,
    classes,
}: Readonly<{
    rows: unknown[]
    defaultSelected: number[]
    handleSelect: (ids: Set<number>) => void
    classes: Record<string, string>
}>) => {
    const getLabel = useLabel()

    return (
        <SkyNetDataGrid
            persistentKey="DEMO-create-quote-add-fees"
            customDataSource={applyDataToDataSource(rows)}
            columns={finalSelectionAdditionalFeesColumns}
            toolbarProps={{
                title: getLabel('ADDITIONAL_FEES'),
                toolbarControls: [],
                showClearSort: false,
            }}
            selectionType={SelectionType.Checkbox}
            getRowId={(row) => {
                return row.additionalFeesFeeId
            }}
            selectedRows={defaultSelected}
            onSelectedRow={handleSelect}
            classNames={{
                tableWrapper: classes.tableWrapper,
            }}
        />
    )
})
